import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 309  -  解锁收集项
 */

export default class EventUnlockCollect extends EventBase {
  constructor() {
    super()
    this.Parameter = ['0', '0', '0', '', '', '']
  }

  // #region 事件内主要属性参数
  get OneIndex() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set OneIndex(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  get TwoIndex() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set TwoIndex(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 是否分享
   */
  get IsShare() {
    return this.Parameter?.[2] === '1'
  }
  set IsShare(value) {
    this.Parameter![2] = value ? '1' : '0'
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter?.[3] ?? ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 扩展字段
   */
  get ObligateString1() {
    return this.Parameter?.[4] ?? ''
  }
  set ObligateString1(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * 扩展字段
   */
  get ObligateString2() {
    return this.Parameter?.[5] ?? ''
  }
  set ObligateString2(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  //   // #endregion
  Code = EventID.UnlockCollect

}
